import useBatchStoreShared from "@adora/shared/features/batches/use-batch-store";

export default function useBatchStore() {
  return useBatchStoreShared();
}
